import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	overDescription: {
		id: 'software-cycle-time-breakdown-report.common.trend-summary.over-description',
		defaultMessage: 'over 12-week median',
		description:
			'Description of the comparison between the current period and the prior period duration. To be combined with a duration. e.g. 2 days 12 hrs over 12-week median',
	},
	underDescription: {
		id: 'software-cycle-time-breakdown-report.common.trend-summary.under-description',
		defaultMessage: 'under 12-week median',
		description:
			'Description of the comparison between the current period and the prior period duration. To be combined with a duration. e.g. 2 days 12 hrs under 12-week median',
	},
	equalDescription: {
		id: 'software-cycle-time-breakdown-report.common.trend-summary.equal-description',
		defaultMessage: 'Same time as 12-week median',
		description:
			'Description of the comparison between the current period and the prior period duration',
	},
});
